import { useCallback } from "react";

import { useActivitiesUrlDependencies } from "org/dashboard/hooks/useActivitiesUrlDependencies";
import {
    ActivitiesUrlParams,
    buildCanonicalActivitiesUrl,
} from "org/dashboard/utils/activitiesUrl";

import { useControlHealthFilters } from "./filters/ControlHealthFiltersProvider";

export function useBuildStatusBreakdownUrl(): (
    controlProgramId: number,
    statusKey?: ActivitiesUrlParams["statusKey"],
    timeToDueDateFilter?: ActivitiesUrlParams["timeToDueDateFilter"]
) => string {
    const { filters, dateRange } = useControlHealthFilters();
    const dependencies = useActivitiesUrlDependencies();

    return useCallback(
        (controlProgramId, statusKey, timeToDueDateFilter) =>
            buildCanonicalActivitiesUrl(
                {
                    dateRange,
                    statusKey: statusKey ?? null,
                    timeToDueDateFilter,
                    filteredControlProgramIds: [controlProgramId],
                    filteredTags: filters.tags,
                    filteredEntityIds: filters.entities,
                    showArchivedActivities: filters.showArchivedActivities,
                    showInactivePrograms: filters.showInactivePrograms,
                },
                dependencies
            ),
        [filters, dateRange, dependencies]
    );
}
